<template>
  <TableList
    v-rect-loading="loading"
    class="meeting-room-management-list"
    row-key="id"
    :title="$t(`${i18nPrefix}.title.interviewMeetingRoomManagement`)"
    :createBtnLabel="$t(`${i18nPrefix}.btn.addInterviewMeetingRoom`)"
    :listData="interviewMeetingRoomList"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    @create="handleAddInterviewMeetingRoom"
  >
    <template #filter>
      <div class="header-search">
        <el-input
          v-model="keywords"
          clearable
          class="search-input"
          :title="$t(`${i18nPrefix}.placeholder.search`)"
          :placeholder="$t(`${i18nPrefix}.placeholder.search`)"
          @input="handleKeywordsChange"
        >
        </el-input>
      </div>
    </template>
    <template #page-bottom>
      <DialogWrapper
        :show.sync="deleteDialog.show"
        :loading="deleteDialog.loading"
        :title="deleteDialog.title"
        @save="handleConfirmDelete"
      />
    </template>
  </TableList>
</template>

<script>

import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { getI18nPropertyValue } from '@/i18n'
import _ from 'lodash'

export default {
  components: {
    DialogWrapper,
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.company.interviewMeetingRoomManagement',
      loading: false,
      interviewMeetingRoomList: [],
      keywords: null,
      deleteDialog: {
        show: false,
        loading: false,
        title: null,
        id: null
      }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.cnName`),
          dataKey: 'cn_name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.name`),
          dataKey: 'name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.address`),
          dataKey: 'address'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.email`),
          dataKey: 'email'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.note`),
          dataKey: 'note'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: true,
          onclick: this.handleEditInterviewMeetingRoom
        },
        delete: {
          show: true,
          onclick: this.handleDeleteInterviewMeetingRoom
        }
      }
    }
  },
  created () {

  },
  methods: {
    ...mapActions('interviewMeetingRoom', ['getInterviewMeetingRoomList', 'deleteInterviewMeetingRoom']),
    async initData () {
      this.loading = true
      try {
        await this.loadInterviewMeetingRoomList()
      } finally {
        this.loading = false
        this.isFirst = false
      }
    },
    async loadInterviewMeetingRoomList () {
      this.loading = true
      try {
        const params = {
          keywords: this.keywords
        }
        const resp = await this.getInterviewMeetingRoomList(params)
        this.interviewMeetingRoomList = resp
      } finally {
        this.loading = false
      }
    },
    handleKeywords () {
      this.$router.push({ query: { keywords: this.keywords } })
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.handleKeywords, 1000)
      }
      this.keywordsSearchDebounce()
    },
    handleAddInterviewMeetingRoom () {
      this.$router.push({ path: '/v-admin/interview-meeting-room/management/add', query: this.$route.query })
    },
    handleEditInterviewMeetingRoom (row) {
      this.$router.push({ path: `/v-admin/interview-meeting-room/management/edit/${row.id}`, query: this.$route.query })
    },
    handleDeleteInterviewMeetingRoom (row) {
      this.deleteDialog.id = row.id
      this.deleteDialog.title = this.$t(`${this.i18nPrefix}.message.deleteInfo`, { name: getI18nPropertyValue(row, 'cn_name', 'en_name'), address: row.address })
      this.deleteDialog.show = true
    },
    async handleConfirmDelete () {
      this.deleteDialog.loading = true
      try {
        const resp = await this.deleteInterviewMeetingRoom({ id: this.deleteDialog.id })
        if (resp === 'success') {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.deleteSuccess`))
          this.deleteDialog.show = false
          this.initData()
        }
      } finally {
        this.deleteDialog.loading = false
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        const keywords = this.$route.query.keywords
        this.keywords = keywords
        this.initData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.meeting-room-management-list {

}
</style>
